<!-- <div>{{field?.name}}</div> -->
<div [ngSwitch]="field.controlType">
    <ng-container *ngSwitchCase="'singleMeasure'">
        <kve-single-measure [field]="field"></kve-single-measure>
    </ng-container>
    <ng-container *ngSwitchCase="'multiMeasure'">
        <kve-border-input [field]="field"></kve-border-input>
    </ng-container>
    <ng-container *ngSwitchCase="'border'">
        <kve-border-input [field]="field"></kve-border-input>
    </ng-container>
    <ng-container *ngSwitchCase="'margin'">
        <kve-margin-input></kve-margin-input>
    </ng-container>
    <ng-container *ngSwitchCase="'color-picker'">
        <kve-background-input [field]="field" [popOver]="popOver"></kve-background-input>
    </ng-container>
    <ng-container *ngSwitchCase="'theme-color-picker'">
        <kve-theme-color-picker [field]="field" (updateField)="onFieldUpdate($event)"></kve-theme-color-picker>
        <!-- <kve-background-input></kve-background-input> -->
    </ng-container>
    <ng-container *ngSwitchCase="'seo'">
        <kve-seo-input></kve-seo-input>
    </ng-container>
    <ng-container *ngSwitchCase="'radio'">
        <div class="radio-wrapper">
            <kve-radio-options [field]="field" (updateField)="onFieldUpdate($event)"></kve-radio-options>
        </div>
    </ng-container>
    <ng-container *ngSwitchCase="'toggle'">
        <kve-toggle [field]="field" (updateField)="onFieldUpdate($event)"></kve-toggle>
    </ng-container>
    <ng-container *ngSwitchCase="'select'">
        <kve-select-field-editor [field]="field" (updateField)="onFieldUpdate($event)"></kve-select-field-editor>
    </ng-container>
    <ng-container *ngSwitchCase="'text-color-picker'">
        <kve-text-color-picker [field]="field" (updateField)="onFieldUpdate($event)"></kve-text-color-picker>
    </ng-container>
    <ng-container *ngSwitchCase="'string'">
        <input nbInput type="text" class="input-field" #valueField fullWidth fieldSize="tiny" [name]="field.name">
        <button nbButton size="tiny" fullWidth status="primary"type="submit" (click)="onSubmitInput({name:field.name,value:valueField.value})">Submit</button>
    </ng-container>
    <ng-container *ngSwitchCase="'text'">
        <kve-text-field-editor [field]="field" (updateField)="onFieldUpdate($event)"></kve-text-field-editor>
        <!-- <input [attr.readonly]="readonly || null" nbInput type="text" class="input-field" #valueField fullWidth fieldSize="tiny" [name]="field.name" [value]="field.value">
        <button *ngIf="!readonly" nbButton size="tiny" fullWidth status="primary"type="submit" (click)="onSubmitInput({name:field.name,value:valueField.value})" class="field-submit-btn">Submit</button> -->
    </ng-container>
    <ng-container *ngSwitchCase="'font'">
        <kve-font-input [field]="field"></kve-font-input>
    </ng-container>
    <ng-container *ngSwitchCase="'font'">
        <kve-toggle [field]="field"></kve-toggle>
    </ng-container>
   
    <!-- <input *ngSwitchCase="'string'" nbInput type="text" fullWidth fieldSize="tiny">
    <input *ngSwitchCase="'colorString'" nbInput type="text" [(colorPicker)]="color"
    [style.background]="color" class="narrow" fieldSize="tiny">
    <span *ngSwitchCase="'types'">
        <ngx-multi-type types="{{field.types}}" name="{{name}}"></ngx-multi-type>
    </span>
    <input *ngSwitchCase="'number'" type="number" formControlName="{{name}}" ngx-number nbInput fieldSize="tiny">
    <input *ngSwitchCase="'boolean'" type="checkbox"  formControlName="{{name}}" fieldSize="tiny">
    <nb-select *ngSwitchCase="'fontWeight'" placeholder="Select weight" formControlName="{{name}}" fullWidth class="form-control-sm" fieldSize="tiny">
        <nb-option [value]="normal">Normal</nb-option>
        <nb-option [value]="bold">Bold</nb-option>
        <nb-option [value]="bolder">Bolder</nb-option>
        <nb-option [value]="lighter">Lighter</nb-option>
    </nb-select>
    <nb-select *ngSwitchCase="'verticalAlign'" placeholder="Select Alignment" formControlName="{{name}}" class="form-control-sm" fieldSize="tiny">
        <nb-option [value]="top">Top</nb-option>
        <nb-option [value]="middle">Middle</nb-option>
        <nb-option [value]="bottom">Bottom</nb-option>
    </nb-select>
    <nb-select *ngSwitchCase="'horizontalAlign'" placeholder="Select Alignment" formControlName="{{name}}" class="form-control-sm" fieldSize="tiny">
        <nb-option [value]="left">Left</nb-option>
        <nb-option [value]="center">Center</nb-option>
        <nb-option [value]="right">Right</nb-option>
    </nb-select>
    <nb-select *ngSwitchCase="'fontFamily'" placeholder="Select Font" formControlName="{{name}}" class="form-control-md" fieldSize="tiny">
        <nb-option *ngFor="let fontOption of fontFamilyOptions" [value]="fontOption"> {{ fontOption }} </nb-option>
    </nb-select> -->
</div>

<!-- <div>{{field?.controlType}}</div> -->
